import styled from 'styled-components';
import { Button } from '@material-ui/core';

// CONSTANTS
import colors, { WHITE, BLACK, WATERLOO, SANTAS_GRAY } from '@/constants/colors';
import { breakpoints } from '@/utility/breakpoints';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  padding: 27px 30px;

  background-color: ${p => (p.type === 'default' ? WHITE : BLACK)};
  transition: all 0.4s;

  border-radius: 6px;
  cursor: default;

  p {
    transition: color 0.4s;
    font-weight: 500;
    color: ${p => (p.type === 'default' ? WATERLOO : SANTAS_GRAY)};

    &.title {
      color: ${p => (p.type === 'default' ? colors.text : WHITE)};
    }
  }

  &:hover {
    box-shadow: 0 30px 60px ${colors.appCard.hover.shadow};

    .title {
      color: ${colors.primary};
    }
  }

  ${breakpoints.down('xs')} {
    padding: 30px;

    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

export const TitleContainer = styled.div`
  margin-right: 30px;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;

  ${breakpoints.down('xs')} {
    padding-top: 20px;

    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

export const PriceSection = styled.div`
  margin-right: 30px;
  line-height: 2.6rem;
  font-weight: 500;

  .price {
    font-size: 2.6rem;
  }

  .period {
    color: ${SANTAS_GRAY};
    font-size: 2rem;
  }

  ${breakpoints.down('xs')} {
    margin-right: 0;
  }
`;

export const ButtonStyled = styled(Button)`
  transition: all 0.4s;
  white-space: nowrap;

  &:hover {
    background-color: ${p => p.theme.palette.primary.main};
    color: ${p => p.theme.palette.primary.contrastText};
    border-color: ${p => p.theme.palette.primary.main};
  }

  ${breakpoints.down('xs')} {
    margin-top: 30px;
  }
`;

export default Wrapper;
